// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DiscoverySourceSchema = z.enum(['CRAWLEE','KATANA','JAVASCRIPT','SOURCE_CODE','SWAGGER','MANUAL','DIRECTORY_SCAN','WIZ_INTEGRATION','HACKERONE_INTEGRATION','BUGCROWD_INTEGRATION','UPWIND_INTEGRATION','PULL_REQUESTS','SCANNER_IMPORT'] as const);

export type DiscoverySourceType = `${z.infer<typeof DiscoverySourceSchema>}`

export default DiscoverySourceSchema;
